import { LanguageEnum, memoize } from '@luminovo/commons';

/** A memoized `Intl.DateTimeFormat` for any locale, so no per-language switch has to stay exhaustive. */
// Annotated: the inferred type names lodash's `MemoizedFunction`, which needs `@types/lodash`.
export const getOrCreateDateTimeFormatter: (locale: string, opts?: Intl.DateTimeFormatOptions) => Intl.DateTimeFormat =
    memoize(
        function getOrCreateDateTimeFormatter(locale: string, opts?: Intl.DateTimeFormatOptions): Intl.DateTimeFormat {
            return new Intl.DateTimeFormat(locale, opts);
        },
        (locale, opts) => JSON.stringify({ locale, opts }),
    );

/** The BCP-47 tag for date formatting: `en` is British (day/month/year), for Luminovo's European users. */
export const dateFormattingLocale = (locale: LanguageEnum): string => (locale === 'en' ? 'en-GB' : locale);
